import { render, staticRenderFns } from "./PerUseFee.vue?vue&type=template&id=24987382&scoped=true"
import script from "./PerUseFee.vue?vue&type=script&lang=js"
export * from "./PerUseFee.vue?vue&type=script&lang=js"
import style0 from "./PerUseFee.vue?vue&type=style&index=0&id=24987382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24987382",
  null
  
)

export default component.exports